import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, obj = logged in

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const value = useMemo(() => {
    const login = async (email, password) => {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return data;
    };
    const register = async (payload) => {
      const { data } = await api.post("/auth/register", payload);
      setUser(data);
      return data;
    };
    const logout = async () => {
      try { await api.post("/auth/logout"); } catch (err) { console.error("Logout request failed (session cleared locally):", err); }
      setUser(false);
    };
    return { user, setUser, login, register, logout };
  }, [user]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
